import * as u from './utils';
import ValidForm from '@pageclip/valid-form';

export default () => {
    //Process response from AJAX requests
    function handleResponse(form, message) {
        const thanks = document.createElement('div');
        u.addClass(thanks, 'response');
        thanks.innerHTML = `<p class="response__thanks">${JSON.parse(message)}</p>`;

        form.parentNode.replaceChild(thanks, form);
    }

    // Handle form submission
    function handleSubmit(e) {
        e.preventDefault();
        const form = e.target;

        // Stop repeated submissions
        if (form.dataset.loading === 'true') {
            return false;
        }

        form.dataset.loading = 'true';

        // Format request data
        const data = new FormData(form);
        data.append('action', form.getAttribute('action'));
        data.append('security', WP.nonce);

        // Send the request
        let responseStatus, message;

        fetch(WP.ajax, {
            method: 'POST',
            body: data,
        })
            .then((response) => {
                responseStatus = response.status;
                return response.json();
            })
            .then((response) => {
                switch (responseStatus) {
                    case 200:
                    case 201:
                    case 202:
                        if (response.data.message) {
                            message = response.data.message;
                        } else {
                            message = WP.translate.thanks;
                        }
                        break;
                    default:
                        message = WP.translate.error;
                        break;
                }

                if (u.hasClass(form, 'marketing-popup__form')) {
                    let payload = {};

                    if (response.success) {
                        payload = { contactId: response.data.contact_id };
                    }

                    const marketingFormSubmission = new Event('marketing-form-submission');
                    marketingFormSubmission.detail = payload;

                    document.body.dispatchEvent(marketingFormSubmission);
                }

                handleResponse(form, message);
            })
            .catch(() => {
                message = WP.translate.thanks;
                handleResponse(form, message);
            });
    }

    // Setup form processing
    for (const form of document.getElementsByClassName('js-process-form')) {
        ValidForm(form, { errorPlacement: 'after' });

        form.addEventListener('submit', handleSubmit);
    }
};
